<template>
    <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
        <div class="container p-0">
            <div class="form-group">
                <h3 class="wizard-title text-uppercase">Kundeninformation – Organisation</h3>
            </div>

            <text-field horizontal :disabled="disabled" label="Firma" v-model="formData.company" :validation="$v.formData.company"/>
            <text-field horizontal :disabled="disabled" label="Adresse" v-model="formData.address" :validation="$v.formData.address"/>
            <text-field horizontal :min="1000" :max="99999" :disabled="disabled" label="PLZ" v-model="formData.postal" :validation="$v.formData.postal"/>
            <text-field horizontal :disabled="disabled" label="Ort" v-model="formData.city" :validation="$v.formData.city"/>
            <select-menu horizontal :disabled="disabled" :options="countries" label="Land" v-model="formData.country" :validation="$v.formData.country"/>
            <text-field horizontal :disabled="disabled" label="Website" v-model="formData.website" :validation="$v.formData.website"/>

            <be-form-group horizontal v-if="!disabled">
                <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$router.push('/')">abbrechen</button>
                <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit">weiter</button>
            </be-form-group>
        </div>
    </form>
</template>

<script>
    import { required, url } from 'vuelidate/lib/validators';
    import { postal } from '../../../validators';

    import Countries from '../../../data/Countries';

    import exam from '../../../mixins/exam';

    export default {
        mixins: [exam],

        data: () => ({
            formData: {
                company: '',
                address: '',
                postal: '',
                city: '',
                country: '',
                website: '',
            },
        }),

        asyncComputed: {
            countries: () => Countries.all(),
        },

        validations: {
            formData: {
                company: { required },
                address: { },
                postal: { required, postal: postal('country') },
                city: { required },
                country: { required },
                website: { required, url },
            },
        },
    };
</script>
